import { Toast } from "components";
import { TOAST_TYPES_ENUM } from "enums";

export const OFFLINE_ONLY_ACTION_MESSAGE =
  "Ta akcja jest dostępna tylko online. Połącz się z internetem i spróbuj ponownie.";

export const notifyOfflineOnlyAction = () => {
  // W tym projekcie Toast dla SUCCESS/ERROR robi `toast.update(id)`.
  // To wymaga, żeby toast o danym id już istniał — więc tworzymy go jako LOADING,
  // a następnie natychmiast aktualizujemy do ERROR z właściwym komunikatem.
  const id = "offline-only-action";

  console.log('zobaczmy')

  Toast({ id, type: TOAST_TYPES_ENUM.LOADING, message: "" });
  // Mikro-opóźnienie ułatwia React-owi/Toastify domknąć render LOADING zanim zrobimy update.
  window.setTimeout(() => {
    Toast({
      id,
      type: TOAST_TYPES_ENUM.ERROR,
      message: OFFLINE_ONLY_ACTION_MESSAGE,
    });
  }, 30);
};
